module.exports = __webpack_public_path__ + "img/success-with-bosspack.74c95d5e.svg";